import { connect } from 'react-redux';
import View from './DebtManagementView';
import MobileView from '../../MobileFinancialPlan/MobileDebtManagement/MobileDebtManagementView';
import { setReactCalibrationWidget, updateGoalViewState } from '../FinancialPlanActions';
import {
  goalId as goalIdSelector,
  selectedGoal as selectedGoalSelector,
  goalViewState as goalViewStateSelector,
} from '../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import { getGoal } from '../FinancialPlanHelpers';
import * as financialPlanSelector from '../FinancialPlanSelector';
import { isCurrentPlanSelector } from '../../PlanSelectionNewWhatIfs/PlanSelectionNewWhatIfsSelector';
import { OVERVIEW } from '../Explanations/ExplanationsConst';

const mapStateToProps = (state, ownProps) => {
  const data = financialPlanSelector.data(state, ownProps);
  const goal = getGoal(data, goalIdSelector(state, ownProps));
  const isGoalDebtManagement = goal.GoalType === 'debtmanagement';
  const selectedSection = goalViewStateSelector(state, ownProps).selectedSection || OVERVIEW;
  const selectedGoal = selectedGoalSelector(state, ownProps);

  if (ownProps.isPrint) {
    return {
      goal: ownProps.goal,
      goalId: ownProps.goal.GoalId,
      data: ownProps.data,
      chartTitle: ownProps.goal.GoalName,
      chartData: ownProps.goal.GoalCharts.Data,
      calibration: financialPlanSelector.calibration(state, ownProps),
      hasGoal: true,
      selectedSection,
      debtManagementAssumptions: ownProps.goal.GoalAssumptions,
      isSubGoal: ownProps.goal.isSubGoal,
    };
  }

  if (isGoalDebtManagement) {
    return {
      goalId: goal.GoalId,
      data,
      chartTitle: selectedGoal.GoalName,
      chartData: selectedGoal.GoalCharts.Data,
      calibration: financialPlanSelector.calibration(state, ownProps),
      hasGoal: isGoalDebtManagement,
      isCurrentPlan: isCurrentPlanSelector(state, ownProps),
      selectedSection,
      debtManagementAssumptions: goal.GoalAssumptions,
      isSubGoal: selectedGoal.isSubGoal,
    };
  }

  return {
    goalId: '',
    data,
    chartTitle: '',
    chartData: [],
    calibration: {},
    hasGoal: isGoalDebtManagement,
    selectedSection,
    debtManagementAssumptions: {},
  };
};

const mapDispatchToProps = dispatch => ({
  setReactCalibrationWidget: (calibrationParams, clientId) =>
    dispatch(setReactCalibrationWidget(calibrationParams, clientId)),
  updateGoalViewState: (goalId, clientId) =>
    dispatch(
      updateGoalViewState(goalId, clientId, {
        selectedSection: OVERVIEW,
      }),
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
export const MobileDebtManagement = connect(mapStateToProps, mapDispatchToProps)(MobileView);
